/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationUpdate
 */
export interface NotificationUpdate {
    /**
     * 
     * @type {string}
     * @memberof NotificationUpdate
     */
    topic: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationUpdate
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationUpdate
     */
    user: number | null;
}

export function NotificationUpdateFromJSON(json: any): NotificationUpdate {
    return NotificationUpdateFromJSONTyped(json, false);
}

export function NotificationUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'topic': json['topic'],
        'type': json['type'],
        'user': json['user'],
    };
}

export function NotificationUpdateToJSON(value?: NotificationUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'topic': value.topic,
        'type': value.type,
        'user': value.user,
    };
}


